import React from "react";
import { Button, Typography } from "../core";
import { Row } from "antd";

const Notify_Utils = require("../helper/utils/Notification");

const DeleteModal = ({ onCancel, delete_func }) => {
  return (
    <React.Fragment>
      {Error.id === "DELETE_BUYER_FAIL" ? (
        Notify_Utils.openNotificationWithIcon(
          "error",
          "Error While Deleting Buyer"
        )
      ) : Error.id === "DELETE_CONTRACT_FAIL" ? (
        Notify_Utils.openNotificationWithIcon(
          "error",
          "Error While Deleting Contract"
        )
      ) : // DELETE_CONTRACT_SUCCESS
      Error.id === "DELETE_CONTRACT_SUCCESS" ? (
        <>
          {Notify_Utils.openNotificationWithIcon("success", Error.msg)}

          {onCancel()}
        </>
      ) : Error.id === "DELETE_BUYER_SUCCESS" ? (
        <>
          {Notify_Utils.openNotificationWithIcon("success", Error.msg)}

          {onCancel()}
        </>
      ) : null}
      <Row tyep="flex" justify="space-between">
        <Button bg="#233B67" width="100px">
          <Typography
            as="h5"
            align="center"
            weight="bold"
            noMargin
            color="white"
            onClick={onCancel}
          >
            No
          </Typography>
        </Button>
        <Button bg="#233B67" width="100px" onClick={delete_func}>
          <Typography
            as="h5"
            align="center"
            weight="bold"
            noMargin
            color="white"
          >
            Yes
          </Typography>
        </Button>
      </Row>
    </React.Fragment>
  );
};

export default DeleteModal;
